/**
 * @generated SignedSource<<b1925faea66fd371ea9056cb2a0e7bca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip$data = {
  readonly members: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip";
};
export type projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip$key = {
  readonly " $data"?: projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectStatusUpdateCardFooter_AtlassianConversationAssistantMessageActions_CardFooterWithTooltip",
  "selections": [
    {
      "concreteType": "TownsquareUserConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareUserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "TownsquareProject"
};

(node as any).hash = "8191eccd37f2b80fef62227d972d0794";

export default node;
